import { createRouter, createWebHistory } from 'vue-router';
import home from '../views/home/index.vue';
import about from '../views/about/index.vue';
import cases from '../views/cases/index.vue';
import products from '../views/products/index.vue';
import contact from '../views/contact/index.vue';
import cooperation from '../views/cooperation/index.vue';
const routes = [
    {
        path: '/',
        name: 'home',
        component: home
    },
    {
        path: '/about',
        name: 'about',
        component: about
    },
    {
        path: '/cases',
        name: 'cases',
        component: cases
    },
    {
        path: '/products',
        name: 'products',
        component: products
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact
    },
    {
        path: '/cooperation',
        name: 'cooperation',
        component: cooperation
    }
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
export default router;
